/*
 * 用于详情页的字段展示
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-27 16:49:03
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-12-31 12:25:07
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.less';

const prefixCls = 'eh-col-component';

export default function ColItem (props) {
	const {
		label, children, width, isPic,
		style, className, labelAlign,
	} = props;
	const wrapCls = classnames({
		[prefixCls]: true,
		[className]: !!className,
		[`${prefixCls}-labelAlignLeft`]: labelAlign === 'left',
		[`${prefixCls}-labelAlignRight`]: labelAlign === 'right',
	});
	return (
		<div className={wrapCls} style={style}>
			<div
			  className={`${prefixCls}-label`}
				style={{ width: width }}
			>
			  {label}
			</div>
			<div style={{
				marginTop: isPic ? '-10px' : 0,
				whiteSpace: 'pre-wrap'
			}}
			>
			  {!children && children !== 0 ? '--' : children}
			</div>
		</div>
	);
}

ColItem.defaultProps = {
	className: '',
	style: {},
	isPic: false,
	width: 'auto',
	labelAlign: 'right'
};

ColItem.propTypes = {
	label: PropTypes.string, // 属性值
	style: PropTypes.object, // 样式
	className: PropTypes.string, // classname
	width: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]), // 宽
	isPic: PropTypes.bool, // 是否是图片
	labelAlign: PropTypes.oneOf(['left', 'right']),
	children: PropTypes.oneOfType([ // 子节点
		PropTypes.string,
		PropTypes.number,
		PropTypes.element,
		PropTypes.array,
	])
};
